import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PriceOptionEnum } from '../../enums';


@Component({
  selector: 'rnpl-price-option-control',
  templateUrl: './price-option-control.component.html',
})
export class PriceOptionControlComponent {

  public priceOptionEnum = PriceOptionEnum;

  @Input() control: FormControl;
  @Input() disabled: boolean = false;
  @Output() fieldChanged: EventEmitter<PriceOptionEnum> = new EventEmitter<PriceOptionEnum>();


  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.hasOwnProperty('disabled') && this.disabled && this.control) {
      this.control.disable();
    }
  }

  public updateField(fieldValue: PriceOptionEnum): void {
    this.fieldChanged.emit(fieldValue);
  }

}
